// @flow
/** @jsx isolateComponent */
/**
 * @alejandro
 * This will be moved to ZDS after the first release.
 */

import { Fragment } from 'react';

import { Colors as DesignSystemColors, Text } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

type OptionShape = {
  id: string,
  label: string,
  onChange?: () => {},
};

const Styles = labelStyles('Option', {
  radio: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: 1,

    '+ label:before': {
      borderColor: DesignSystemColors.gray40,
    },

    '&:checked + label:before': {
      backgroundColor: DesignSystemColors.ocean,
      borderColor: DesignSystemColors.ocean,
    },

    '&:focus + label:before': {
      // Box shadow preserves border-radius and leaves "selected" border styling intact so focus styling is in addition to selected styling.
      boxShadow: `0 0 2px 2px ${DesignSystemColors.ocean}`,
    },
  },
  label: {
    alignItems: 'center',
    display: 'flex',
    marginRight: 10,
    '&:before': {
      content: "''",
      backgroundClip: 'content-box',
      backgroundColor: 'transparent',
      borderRadius: '100%',
      borderStyle: 'solid',
      borderWidth: 2,
      boxSizing: 'content-box',
      display: 'inline-block',
      height: 10,
      marginRight: 8,
      padding: 3,
      verticalAlign: -3,
      width: 10,
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

const Option = ({ id, label, onChange }: OptionShape) => {
  return (
    <Fragment>
      <input
        css={Styles.radio}
        id={id}
        name="mp-survey"
        onChange={onChange}
        type="radio"
        value={id}
      />
      <label css={Styles.label} htmlFor={id}>
        <Text fontWeight="600" type="smallPrint1">
          {label}
        </Text>
      </label>
    </Fragment>
  );
};

Option.defaultProps = {
  onChange: () => {},
};

export default Option;
